import { LegacyIcon } from '@gonfalon/icons/LegacyIcon';
import type { LegacyIconProps } from '@gonfalon/icons/types';
import cx from 'clsx';

import VercelSvgColor from '../assets/vercel.svg';

export const VercelWhiteColor = ({ className, size, ...props }: LegacyIconProps) => (
  <LegacyIcon name="color-lang-vercel" className={cx('sdkIcon', className)} size={size} {...props}>
    <VercelSvgColor />
  </LegacyIcon>
);
